export default __webpack_public_path__ + "images/6A.145a921.png";